/**
 * String slugify
 * https://gist.github.com/codeguy/6684588#gistcomment-3231045
 *
 * @param {string} text
 */
const slugify = (text) => {
  const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
  const to = 'aaaaaeeeeeiiiiooooouuuunc------';

  const newText = text.split('').map((letter, i) => letter.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)));

  /** Remove this eslint after unit testing to verify removing the  */
  /* eslint-disable no-useless-escape */
  return newText
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-y-') // Replace & with 'and'
    .replace(/[^\w\\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
  /* eslint-enable  */
};

// eslint-disable-next-line import/prefer-default-export
export { slugify };
